module.exports = __webpack_public_path__ + "assets/7ddc43ac5e20ee63aa3d0c6bcd09930c.png";